import { Box, Heading, Text } from "@chakra-ui/react"
import { useLocation, useNavigate } from "react-router-dom"
import { QuizSelector_data } from '../Quiz_data/Quiz_data.js'
import { RoadMap } from "../RoadMap/RoadMap.jsx"
import { useEffect } from "react"



export const QuizSelector = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const language = queryParams.get('language');

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the new page
    }, []);

    return (
        <Box minH={'100vh'} color={'white'} pb={'1cm'} bg={'linear-gradient(30deg, rgb(0, 7, 61), rgb(0, 10, 63), rgb(0, 13, 66), rgb(0, 16, 68), rgb(0, 19, 71), rgb(0, 22, 73), rgb(0, 25, 76), rgb(0, 28, 78), rgb(0, 31, 80), rgb(0, 34, 83), rgb(0, 37, 85), rgb(0, 40, 88), rgb(0, 43, 90), rgb(0, 46, 92), rgb(0, 49, 95), rgb(0, 52, 97), rgb(0, 55, 100), rgb(0, 58, 102), rgb(0, 61, 105), rgb(0, 64, 107))'}>

            <Box onClick={() => navigate('/quiz')} cursor={'pointer'} w={'fit-content'} display={'flex'} gap={'10px'} p={'15px'} pb={'0.5cm'}>
                <Text color={'orange'} fontSize={'25px'} fontWeight={'bold'}>|| Quiz</Text>
                <Text color={'white'} fontSize={'25px'} fontWeight={'bold'}>Time</Text>
            </Box>

            <Heading w={'fit-content'} m={'auto'} display={'flex'} gap={'10px'}>
                <Text>{language}</Text>
                <Text color={'orange'}>Quiz</Text>
            </Heading>

            <Box w={'80%'} display={'flex'} gap={'10px'} m={'1.5cm auto'} flexWrap={'wrap'}>
                {QuizSelector_data[language] && QuizSelector_data[language].length != 0 && QuizSelector_data[language]?.map((ele, index) => (
                    <Box onClick={() => navigate(ele.url)} key={index} w={'70px'} h={'70px'} border={`2.5px solid ${ele.bordercolor}`} color={'white'} display={'flex'} justifyContent={'center'} alignItems={'center'} fontWeight={'bold'} fontSize={'25px'} cursor={'pointer'} _hover={{ color: 'orange' }} transition={'0.3s ease'}>
                        {ele.problem}
                    </Box>
                ))}
                <Box w={'70px'} h={'70px'} border={`2.5px solid white`} color={'white'} display={'flex'} justifyContent={'center'} alignItems={'center'} fontWeight={'medium'} fontSize={'16px'} cursor={'pointer'} _hover={{ color: 'orange' }} transition={'0.3s ease'}>Soon...</Box>
            </Box>

            <Box w={'100%'}>

                <Box w={'100%'} textAlign={'center'} fontWeight={'medium'} fontSize={'20px'} p={'20px 0'} bg={'white'} color={'#FF6D00'}>Try Our {language} RoadMap</Box>

                <RoadMap map={language} />
            </Box>
        </Box>
    )
}